import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import stylesJS from "@/assets/styles.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'inputBox',
  props: {
  styles: {
    type: String,
    default: ""
  }
},
  setup(__props) {

const props = __props;

const classList = computed(() => {
  // Import & defaults
  let importOBJ = stylesJS.get(props.styles)
  let iBorder = importOBJ.border || "vl"
  iBorder = "border-" + iBorder
  let iBg = importOBJ.bg || "white"
  iBg = "bg-" + iBg
  let iBgi = importOBJ.bgi
  iBgi = iBgi ? "bgi-" + iBgi : ""
  let iRnd = importOBJ.rnd  || "s"
  iRnd = "rnd-" + iRnd
  let iPad = importOBJ.pad  || "none"
  iPad = "pad-" + iPad

  return ['component', iBg, iBgi, iPad, iBorder, iRnd, 'w-full']
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classList.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})